import {
  Assignment,
  EmptyAssignment,
} from "@/types/models/Assignment.interface";
import { UserProperties } from "@/types/models/UserProperties.interface";

/**
 * If a user is a student and the assigned article has checks for understanding quizzes hidden, return true
 * @param {assignment, userProperties}
 * @return boolean
 */

type StudentUser = Pick<UserProperties, "isStudent" | "canSeeAiFeatures">;

export const shouldIgnoreArticleBlur = ({
  assignment,
  userProperties,
  isStudentPreviewOn,
}: {
  assignment: Assignment | EmptyAssignment;
  userProperties: StudentUser;
  isStudentPreviewOn: boolean;
}) => {
  if (!assignment || !userProperties) return true;

  const { isStudent, canSeeAiFeatures } = userProperties;

  if (!canSeeAiFeatures) return true;
  // @ts-expect-error Property 'content_id' does not exist on type EmptyAssignment
  if (isStudent && !assignment?.content_id) {
    // Students shouldn't see the Blur, when assignment doesn't exist.
    return true;
  }
  const {
    assignment_config: {
      hide_checks_for_understanding: hideChecksForUnderstanding,
    },
  } = assignment;

  if (!isStudent && !isStudentPreviewOn) return true;

  return (isStudent || isStudentPreviewOn) && hideChecksForUnderstanding;
};

export default shouldIgnoreArticleBlur;
